/**
 * Post-logout guard. Set on an explicit logout so the *next* session check skips
 * auto-restore (avoids bouncing a just-logged-out user back into an authed route).
 * It MUST be cleared on any login intent — email, OAuth, and guest — otherwise a
 * stale flag makes the following `checkSession` skip `/me` and wrongly show the
 * user as logged out (and suppresses session-dependent UI like the verify nudge).
 */
const LOGGED_OUT_FLAG = 'logged_out';

/** Mark that the user explicitly logged out. */
export function markLoggedOut(): void {
  sessionStorage.setItem(LOGGED_OUT_FLAG, '1');
}

/** Clear the guard — call on every login path (email / OAuth / guest). */
export function clearLoggedOut(): void {
  sessionStorage.removeItem(LOGGED_OUT_FLAG);
}

/** Read-and-clear the guard. Returns true if the user had just explicitly logged out. */
export function consumeLoggedOut(): boolean {
  if (sessionStorage.getItem(LOGGED_OUT_FLAG)) {
    sessionStorage.removeItem(LOGGED_OUT_FLAG);
    return true;
  }
  return false;
}
